import {
  GraphQLAction,
  FulfillGetFavourites,
  FulfillUpdateFavourites,
} from '../actions/GraphQLActions'
import { FULFILL_GET_FAVOURITES, FULFILL_UPDATE_FAVOURITES } from '../constants'

export function favourites(favouritesState: string[] = [], action: GraphQLAction): string[] {
  switch (action.type) {
    case FULFILL_GET_FAVOURITES: {
      return (action as FulfillGetFavourites).favourites
    }
    case FULFILL_UPDATE_FAVOURITES: {
      return (action as FulfillUpdateFavourites).favourites
    }
    default:
      return favouritesState
  }
}
